<div class="dialog-wrapper">
  <app-not-available-overlay>
    <div class="c-dialog-content">
      <p class="c-dialog-text mb-12-px mt-unset">Fill in the fields to arrange a return for:</p>
      <div class="mb-28-px">
        <div class="selected-item">

          <div class="img-wrapper">
            <img src="./../../../../assets/images/product/mock-images/h-preview 3.png" alt="product-image">
          </div>
          <app-product-details-header [medium]="true" [showLabels]="false"></app-product-details-header>
        </div>
      </div>
      <div class="reason-form">
        <app-dropdown-control [label]="'Reason:'" [options]="reasonList" [control]="reasonControl"
          [name]="'UserAddress'">
        </app-dropdown-control>

        <div class="textarea-wrapper mb-16 borderless primary">
          <textarea placeholder="Comments (Optional):" id="reason-comments" rows="5" cols="30" pInputTextarea
            [formControl]="commentsControl"></textarea>
        </div>

        <div class="inline-upload-images-wrapper">
          <app-upload-images></app-upload-images>
          <app-uploaded-images-list [disableInnerScroll]="true" [disablePaddings]="true"></app-uploaded-images-list>
        </div>
      </div>
    </div>
  </app-not-available-overlay>
  <div class="c-dialog-actions">
    <button (click)="closeDialog()" pButton pRipple class="c-button light cancel">Cancel</button>
    <button (click)="submitReturn()" [disabled]="!reasonControl.valid" pButton pRipple
      class="c-button primary save">Submit</button>
  </div>
</div>
